// removed by extract-text-webpack-plugin
module.exports = {"SearchResultsContainer":"SearchResultsContainer__2E4Zz","NoResults":"NoResults__cFzoS","NoResultsSearchTerm":"NoResultsSearchTerm__ym8WH"};


//////////////////
// WEBPACK FOOTER
// ./routes/HelpDesk/SearchResults/style.scss
// module id = iw93
// module chunks = 0